import React from 'react';
import { useLanguage } from '../../../i18n/LanguageContext';

const SettingsSaveButton = React.memo(({
  onClick,
  isSaving = false,
  label,
  savingLabel,
  variant = 'default',
  className = ''
}) => {
  const { t } = useLanguage();
  const displayLabel = label || t('common.save', 'Kaydet');
  const displaySavingLabel = savingLabel || t('common.saving', 'Kaydediliyor...');
  return (
    <button
      type="button"
      className={`settings-save-btn ${variant === 'compact' ? 'settings-save-btn--compact' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={isSaving}
    >
      {isSaving ? (
        <>
          <i className="fas fa-spinner fa-spin" aria-hidden="true"></i>
          <span>{displaySavingLabel}</span>
        </>
      ) : (
        <>
          <i className="fas fa-check" aria-hidden="true"></i>
          <span>{displayLabel}</span>
        </>
      )}
    </button>
  );
});

export default SettingsSaveButton;
